
  <app-expired [dialogReason]="data.reason" [dialogMessage]="data.message"></app-expired>
